/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_SitemapInputs */

const en_directory_agent_readiness_check_sitemap = /** @type {(inputs: Directory_Agent_Readiness_Check_SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitemap`)
};

const zh_directory_agent_readiness_check_sitemap = /** @type {(inputs: Directory_Agent_Readiness_Check_SitemapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`站点地图`)
};

/**
* | output |
* | --- |
* | "Sitemap" |
*
* @param {Directory_Agent_Readiness_Check_SitemapInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_sitemap = /** @type {((inputs?: Directory_Agent_Readiness_Check_SitemapInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_SitemapInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_sitemap(inputs)
	return zh_directory_agent_readiness_check_sitemap(inputs)
});
export { directory_agent_readiness_check_sitemap as "directory.agent_readiness.check.sitemap" }